<template>
  <v-container grid-list-md pa-0 relative>
    <v-layout row wrap>
      <v-flex xs12 sm12 class="overlay">
        <v-card outlined class="primary--border">
          <v-card-title class="title">Penalty Setup (Delayed Return)</v-card-title>
          <v-spacer></v-spacer>
          <v-divider></v-divider>
          <v-card-text class="ma-0">
            <alert-message type="warning" title="Penalty Setting Alert"
              :message="'The amount configured below will take effect after the expiry date — starting from the day following the book’s issue expiry. Charges will be calculated incrementally for each day after the expiry date.'"></alert-message>
          </v-card-text>
          <v-data-table :headers="headers" :items="items" :loading="loading" hide-default-footer
            :server-items-length="items.length">
            <template v-slot:item="{ index, item }">
              <tr>
                <td>{{ ++index }}</td>
                <td>
                  <strong style="line-height: 0;">{{ item.grade_name }} </strong> <br>
                </td>
                <td>
                  <v-text-field type="number" class="mb-1 mt-1"
                    @keyup="(disabledUpdate = false), (item.is_update = true)" v-model="item.fee_amount" dense outlined>
                  </v-text-field>
                </td>
                <td>
                  <v-select class="mb-1 mt-1" @change="(disabledUpdate = false), (item.is_update = true)"
                    v-model="item.calculation_type"
                    :items="[{ text: 'Percentage', value: 'percentage' }, { text: 'Flat', value: 'flat' }]" dense
                    outlined></v-select>
                </td>
                <td>

                  <v-text-field value="NO CAP" placeholder="NO CAP" disabled type="number" class="mb-1 mt-1" dense
                    outlined>
                  </v-text-field>
                </td>
                <td>

                  <v-text-field value="NO DISCOUNT" placeholder="NO DISCOUNT" disabled type="number" class="mb-1 mt-1"
                    dense outlined>
                  </v-text-field>
                </td>
              </tr>
            </template>
          </v-data-table>
          <br />
          <edit-button @agree="saveRecord" icon="dd" :disabled="disabledUpdate" :outlined="false" :large="true"
            :block="true" color="primary" :label="`Update All Records`" :permission="true" />
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Mixins from '@/library/Mixins';
import { v2Services } from "@/library/helpers";

export default {
  mixins: [Mixins],
  data: () => ({
    disabledUpdate: true,
    items: [],
    loading: false,

    grades: [],
    fetchingGrade: false,
    months: [
      { value: '01', text: 'Baishakh' },
      { value: '02', text: 'Jestha' },
      { value: '03', text: 'Ashad' },
      { value: '04', text: 'Shrawan' },
      { value: '05', text: 'Bhadra' },
      { value: '06', text: 'Asoj' },
      { value: '07', text: 'Kartik' },
      { value: '08', text: 'Mangsir' },
      { value: '09', text: 'Poush' },
      { value: '10', text: 'Magh' },
      { value: '11', text: 'Falgun' },
      { value: '12', text: 'Chaitra' },
      { value: '13', text: 'Baishakh(13)' },
      { value: '14', text: 'Jestha(14)' },
    ],
    multiple: false,
    headers: [
      { text: 'SN', align: 'left', value: 'id', width: 10, sortable: false },
      {
        text: 'Grade',
        align: 'left',
        value: 'grade',
        width: 400,

        sortable: false,
      },
      {
        text: 'Penalty Amount',
        align: 'left',
        value: 'fee_amount',
        sortable: false,
        width: 200,
      },
      {
        text: 'Calculation Type',
        align: 'left',
        value: 'calculation_type',
        width: 200,
        sortable: false,
      },

      {
        text: 'Maximum Cap Amount',
        align: 'left',
        value: 'max_cap_amount',
        width: 300,
        sortable: false,
      },

      {
        text: 'Default Discount',
        align: 'left',
        value: 'default_discount_amount',
        width: 150,
        sortable: false,
      },
    ],
  }),
  mounted() {
    this.getGrades();
    this.get();
  },
  computed: {

  },

  methods: {

    getGrades() {
      this.fetchingGrade = true;
      this.$rest
        .get('/api/grades?rowsPerPage=50&descending=false&slim=true')
        .then(({ data }) => {
          this.fetchingGrade = false;
          this.grades = data.data.map((item) => {
            return { value: item.id, text: item.name, sections: item.sections.map((item) => ({ value: item.id, text: item.name })) };
          });
        });
    },
    get() {
      this.$restV2(v2Services.LIBRARY).get(`/v2/penalty-setup`).then(({ data }) => {
        this.items = data;
      }).finally(() => {
        this.loading = false;
      });
    },
    saveRecord() {
      this.$restV2(v2Services.LIBRARY).post(`/v2/penalty-setup`, { penalties: this.items }).then(({ data }) => {
        this.$events.fire('notification', {
          message: "Penaly settings were saved successfully",
          status: 'success',
        });
        this.disabledUpdate = true;
      }).finally(() => {
        this.loading = false;
      }).catch((err) => {
        this.$events.fire('notification', {
          message: err.response.data.message,
          status: 'error',
        });
      });;
      // this.$rest
      //   .post(`api/billing-month`, {
      //     params: this.items.map((item) => ({
      //       ...item,
      //     })),
      //   })
      //   .then(({ data }) => {
      //     this.get();
      //     this.$events.fire('notification', {
      //       message: data.message,
      //       status: 'success',
      //     });
      //   })
      //   .catch((err) => {
      //     this.$events.fire('notification', {
      //       message: err.response.data.message,
      //       status: 'error',
      //     });
      //   });
    },
  },
};
</script>
